import React, { useEffect, useState } from 'react'
import { portal } from '../portalApi.js'

// 원가관리 화면들이 같이 쓰는 조각. 사업부 선택은 화면마다 따로 놀면 안 되므로
// (배부기준은 에르모어인데 수불부는 통합인 채로 대사하면 숫자가 안 맞는다)
// 브라우저에 담아 두고 모든 원가 화면이 같은 값을 본다.

const KEY = 'cost.company'

export const readCompany = () => {
  try { return localStorage.getItem(KEY) || '' } catch { return '' }
}

export function useCompany() {
  const [company, set] = useState(readCompany)
  const change = (v) => {
    set(v)
    try { localStorage.setItem(KEY, v) } catch { /* 사파리 프라이빗 등 */ }
  }
  return [company, change]
}

// meta는 기준정보라 자주 안 바뀐다. 화면을 옮길 때마다 다시 받지 않게 모듈에 물려 둔다.
let metaCache = null
let metaPromise = null

export function useMeta() {
  const [meta, setMeta] = useState(metaCache)
  const [err, setErr] = useState('')
  useEffect(() => {
    if (metaCache) return
    metaPromise = metaPromise || portal.get('/api/cost/meta')
    metaPromise.then((m) => { metaCache = m; setMeta(m) }).catch((e) => setErr(e.message))
  }, [])
  return [meta, err]
}

export const companyName = (meta, code) =>
  (meta?.companies || []).find((c) => c.code === code)?.name || code || '통합'

export function CompanyPicker({ value, onChange, meta, allowAll = true, label = '사업부' }) {
  return (
    <label className="row" style={{ gap: 6, alignItems: 'center' }}>
      <span className="muted" style={{ fontSize: 13 }}>{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {allowAll && <option value="">통합 (전 사업부)</option>}
        {(meta?.companies || []).map((c) => (
          <option key={c.code} value={c.code}>{c.name}</option>
        ))}
      </select>
    </label>
  )
}

// 빈 값은 빼고 쿼리스트링을 만든다. company가 ''이면 서버가 통합으로 읽는다.
export const qs = (params) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&')

export const costGet = (path, params) => {
  const s = qs(params || {})
  return portal.get(`/api/cost${path}${s ? '?' + s : ''}`)
}

export function useToast() {
  const [toast, setToast] = useState('')
  const notify = (msg, ms = 3000) => { setToast(msg); setTimeout(() => setToast(''), ms) }
  const node = toast ? <div className="toast">{toast}</div> : null
  return [notify, node]
}

// 사업부를 안 고르면 못 하는 동작(충당금 확정 등)에서 쓴다
export function NeedCompany({ children }) {
  return (
    <div className="hint warn-hint" style={{ marginTop: 0 }}>
      {children || '이 작업은 사업부를 하나 골라야 합니다 — 통합 화면에서는 확정할 수 없습니다.'}
    </div>
  )
}

export default function CostCommon() {
  return null
}
